import { api } from '@general/ui-kit'

function query(params = {}) {
  const search = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== '' && value != null)
  ).toString()
  return search ? `?${search}` : ''
}

export const supportApi = {
  /** Categories, priorities, what this person may do, and the state of the bridge. */
  meta:      ()            => api.get('/support/meta'),
  stats:     ()            => api.get('/support/stats'),
  list:      (params = {}) => api.get(`/support/tickets${query(params)}`),
  get:       (id)          => api.get(`/support/tickets/${id}`),
  open:      (data)        => api.post('/support/tickets', data),
  reply:     (id, data)    => api.post(`/support/tickets/${id}/messages`, data),
  update:    (id, data)    => api.patch(`/support/tickets/${id}`, data),
  markRead:  (id)          => api.post(`/support/tickets/${id}/read`),

  /**
   * Attachments go to platform/files first and the ticket references what comes
   * back. Two round trips instead of one multipart form, and worth it: the file
   * store already deduplicates, streams, and enforces the type allow-list, and
   * none of that should be reimplemented per feature.
   *
   * `module: 'support'` is what decides who may read it later — the uploader
   * always, plus whoever holds `support:read`.
   */
  upload: (file) => {
    const form = new FormData()
    form.append('file', file)
    form.append('module', 'support')
    return api.post('/files', form)
  },

  /** An <a href> a browser can follow: the token travels in the URL. */
  fileUrl: (fileId) => api.urlWithToken(`/files/${fileId}`),
}

/**
 * What was on screen when they asked for help.
 *
 * Collected without being asked for, because the alternative is asking — and
 * asking costs a day: the client answers tomorrow, from memory, after the
 * deployment that changed the answer. The server does not trust any of it; it
 * stores it as evidence and fills in what it knows for certain itself.
 */
export function browserContext({ route, locale } = {}) {
  return {
    route: route ?? window.location.pathname,
    // The build the tab is actually running, which is not always the one that
    // is deployed — a tab left open over a release is the single most common
    // explanation for "it works for me".
    appBuild: typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev',
    locale: locale ?? '',
    viewport: `${window.innerWidth}x${window.innerHeight}`,
  }
}
